import { GetterTree } from 'vuex';
import { CateringBotState, RootState } from '../types';

export const getters: GetterTree<CateringBotState, RootState> = {};
